import sessionStorageEx from 'bundles/common/utils/sessionStorageEx';
import { deprecateLegacySgaGraderEnabled } from 'bundles/grading-common/utils/epicUtils';

const SESSION_STORAGE_KEY = 'quick-grader-default-choice';

type GradingAppChoice = 'quickGrader' | 'legacyGrader';
type StorageValue = Record<string, { app: GradingAppChoice }> | undefined;

const defaultChoice: GradingAppChoice = 'quickGrader';

const getGradingAppChoice = (courseId: string): GradingAppChoice => {
  const storeObj = sessionStorageEx.getItem<StorageValue>(SESSION_STORAGE_KEY, JSON.parse, undefined);
  return storeObj?.[courseId]?.app || defaultChoice;
};

const setGradingAppChoice = (courseId: string, choice: GradingAppChoice) => {
  const dataToSave = { [courseId]: { app: choice } };
  sessionStorageEx.setItem<StorageValue>(SESSION_STORAGE_KEY, dataToSave, JSON.stringify);
};

const isQuickGraderDefault = (courseId: string) => {
  if (!deprecateLegacySgaGraderEnabled()) {
    return false;
  }
  return getGradingAppChoice(courseId) === defaultChoice;
};

export default {
  isQuickGraderDefault,
  setGradingAppChoice,
};
